import { z } from 'zod'

// Public submission input -- validated on POST /api/public/contact
export const contactSubmissionInputSchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email().max(320),
  message: z.string().min(1).max(2000),
  honeypot: z.string().optional(),
})

// Admin response shape
export const contactSubmissionSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string(),
  message: z.string(),
  read: z.boolean(),
  ipAddress: z.string(),
  createdAt: z.string().datetime(),
})

export type ContactSubmissionInput = z.infer<
  typeof contactSubmissionInputSchema
>
export type ContactSubmissionResponse = z.infer<typeof contactSubmissionSchema>
